var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFavoritesImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 506.932,
    height: 446.651,
    viewBox: "0 0 440 446.651",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.aa,.ad,.aj,.al,.am,.e,.t{fill:none;}.a,.e{stroke:#78c7e3;}.a,.i,.y{stroke-linecap:round;}.a,.aa,.ab,.ac,.ae,.ag,.ah,.ai,.aj,.ak,.al,.am,.e,.l,.n,.r,.s,.t,.u,.v,.z{stroke-miterlimit:10;}.a{stroke-width:2.08px;}.an,.b{opacity:0.48;}.c{fill:#a6dae8;}.an,.d{fill:#78c7e3;}.e{stroke-width:1.04px;}.f,.o{fill:#eb4d55;}.g{fill:#91d3e5;}.h{fill:#a3d9e8;}.i,.z{fill:#f2c80e;stroke:#f2c80e;}.ad,.i,.y{stroke-linejoin:round;}.ak,.i,.y,.z{stroke-width:1.06px;}.j,.u,.y{fill:#ffbe9e;}.k{fill:#d47770;}.ai,.l{fill:#00aba6;stroke:#00aba6;}.ac,.ag,.ah,.l,.n,.r,.s{stroke-width:0.23px;}.ag,.m{opacity:0.43;}.ag,.n,.r{fill:#ff6f5e;stroke:#ff6f5e;}.o,.x{opacity:0.5;}.ab,.ae,.p{fill:#00263b;}.q{fill:#fff;}.r{opacity:0.37;}.s{fill:#dd6435;stroke:#dd6435;}.ab,.ae,.t{stroke:#00263b;}.aj,.am,.t{stroke-width:0.52px;}.u,.y{stroke:#ffbe9e;}.u{stroke-width:0.93px;}.v,.w,.x{fill:#4092c1;}.al,.am,.v{stroke:#4092c1;}.ai,.v{stroke-width:0.22px;}.aa,.aj{stroke:#eb4d55;}.aa{stroke-width:0.56px;}.ab{stroke-width:0.79px;}.ac{fill:#ff5079;stroke:#ff5079;}.ad{stroke:#fffcf2;stroke-linecap:square;stroke-width:0.47px;}.ae{stroke-width:0.99px;}.af,.ak{fill:#f8eeee;}.ah{fill:#006d67;stroke:#006d67;}.ak{stroke:#f8eeee;}.al{stroke-width:0.55px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-85.839 -101.82)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(86.234 102.35)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "a",
    x2: 458.626,
    transform: "translate(33.589 437.509)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(59.653 227.725)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M195.027,486.507a209.911,209.911,0,0,1-68.206-99.265c-3.725-11.7-6.422-24.007-5.061-36.21s7.424-24.405,17.919-30.712c12.228-7.411,27.809-5.806,41.669-2.338,27.565,6.911,53.948,20.256,82.323,21.117,29.184.9,57.031-11.56,82.965-24.945S398.5,285.819,427.313,281s61.874,2.89,78.482,26.91a73.8,73.8,0,0,1,10.944,26.82c6.178,29.248-.449,59.613-8.837,88.309-6.05,20.757-19.344,49.954-32.883,66.793",
    transform: "translate(-121.401 -279.638)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(339.355 220.514)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M340.908,292.913c28.066-24.11,81.642-24.572,104.3,6.949,9.48,13.192,12.716,28.528,13.8,44.418,1.028,15.118,1.066,30.828-1.657,45.779-.231,1.285,1.7,1.8,1.927.54,3.019-16.57,2.9-34.1,1.374-50.814s-6.23-32.716-17.418-45.638c-13.063-15.093-31.945-20.333-51.379-20.115-18.856.218-37.828,4.984-52.369,17.469-.976.848.45,2.248,1.413,1.413Z",
    transform: "translate(-339.155 -274.025)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M115.24,345.491a8.9,8.9,0,1,1,8.9,8.9A8.9,8.9,0,0,1,115.24,345.491Z",
    transform: "translate(-63.501 -35.712)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M385,392.569A2.569,2.569,0,1,0,387.569,390,2.569,2.569,0,0,0,385,392.569Z",
    transform: "translate(13.243 -20.517)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M453.458,474.534a82.926,82.926,0,0,0,58.714-42.388c5.356-10.16,7.874-24.225-.629-31.945-5.138-4.637-12.781-5.382-19.5-3.853s-12.845,4.958-19.049,7.9a139.487,139.487,0,0,1-35.966,11.406c-3.545.6-8.49.141-8.991-3.43a6.794,6.794,0,0,1,1.464-4.393c12.434-19.691,32.677-35.5,37.25-58.329a19.266,19.266,0,0,0,.244-8.079c-1.362-5.96-7.167-10.109-13.166-11.291-11.342-2.235-22.466,4.1-32.022,10.61C370.249,375.885,329.672,418.2,301.4,473.789",
    transform: "translate(-10.541 -37.679)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(280.648 331.419)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M417.711,465.622a81.6,81.6,0,0,0,48.464-30.9c4.663-6.268,8.542-14.027,6.782-21.644-17.649-18.188-40.41,16.878-61.565,23.468-4.316,1.349-10.481,1.284-11.689-3.044-.552-1.978.283-4.059,1.1-5.947l19.807-45.471c2.492-5.716,4.855-12.781,1.079-17.752-2.569-3.327-7.193-4.444-11.329-3.776s-7.848,2.787-11.432,4.945c-42.183,25.561-73.845,61.321-105.482,99.175",
    transform: "translate(-293.45 -360.366)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(426.217 377.87)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M437.891,397.314c14.5,8.709,7.925,26.679-.809,36.852a70.531,70.531,0,0,1-30.018,20.218c-.5.18-.283.989.218.809,13.9-4.984,27.231-14.129,35.105-26.859,6.333-10.276,7.411-24.791-4.162-31.74-.45-.283-.873.437-.411.719Z",
    transform: "translate(-406.779 -396.53)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(365.028 326.45)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M385.15,436.987c5.5-13.127,10.982-26.255,15.658-39.7,3.275-9.428,9.184-22.08,5.292-32.112-8.914-23.057-38.535,6.14-46.845,15.234-.36.4.218.989.591.591a105.5,105.5,0,0,1,23.121-19.357c6.692-4.059,15.311-7.09,20.757.771,3.584,5.138,2.954,11.779,1.593,17.546-4.6,19.537-13.269,38.406-20.989,56.851-.205.5.6.719.8.231Z",
    transform: "translate(-359.142 -356.498)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M430.14,388.647a8.914,8.914,0,1,1,8.9,8.9A8.914,8.914,0,0,1,430.14,388.647Z",
    transform: "translate(26.084 -23.442)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M296.16,249.444c14.874,5.7,31.38,1.516,38.676-9.39,14.579-21.836,3.648-8.336,1.76-18.921s-10.918-1.8-14.463-3.211c-5.7,11.483-14.643,13.179-23.313,10.764Z",
    transform: "translate(-12.031 -70.065)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M296,249.238c14.874,5.69,31.38,1.5,38.676-9.4,14.579-21.836,3.648-8.323,1.773-18.921s-10.918-1.8-14.476-3.211c-5.69,11.483-14.643,13.179-23.313,10.764Z",
    transform: "translate(-12.077 -70.129)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M268.8,248.993c-3.16,7.553-6.153,23.519-12.126,35.169-6.9,13.436-20.064,25.2-38.368,24.791-9.813-.218-22.979-2.569-33.307-3.853s-3.853-38.535,6.641-36.068c9.9-.437,20.192,1.284,29.774.27,12.01-1.285,18.432-6.718,26.011-16.018,2.8-3.43,6.153-9.4,9.12-13.153a1.888,1.888,0,0,0,.283-1.285c0-.3,0,0-.09-.244-1.092-2.646-7.411-12.28-5.5-14.271s4.778,5.613,5.767,6.422,1.606,2.659,3.147-.552,4.085-17.495,6.872-19.576-1.284,7.591.283,7.476,3.931-7.707,5.472-7.09c1.195.514-1.773,8.426-.886,9.094,1.8,1.349,2.941-6.949,4.855-6.268s-1.477,6.153-1.284,8.388,2.274-5.382,3.558-2.569-4.56,20.2-7.8,23.3C269.22,248.312,271.943,241.453,268.8,248.993Z",
    transform: "translate(-45.141 -71.631)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M214.34,266.73l15.285,20.436s-8.079,4.509-11.406,4.842Z",
    transform: "translate(-35.308 -55.586)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M242.745,225.844c.873-.334,2.877,3.853,1.1,3.661a4.6,4.6,0,0,1-2.89-2Z",
    transform: "translate(-27.735 -67.223)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M232.633,299.335c-9.171.45-32.536.18-43-3.6-9.749-3.52-17.983-12.151-17.186-20.308h0c.822-8.156,10.276-21.836,20.719-19.743,9.955-1.773,20.873-2.286,30.378-3.468",
    transform: "translate(-47.243 -59.714)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "m",
    transform: "translate(125.146 192.506)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M232.633,299.335c-9.171.45-32.536.18-43-3.6-9.749-3.52-17.983-12.151-17.186-20.308h0c.822-8.156,10.276-21.836,20.719-19.743,9.955-1.773,20.873-2.286,30.378-3.468Z",
    transform: "translate(-172.388 -252.22)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M245.593,184.33c10.135-17.983,21.836-36.826,44.071-40.243,26.974-4.136,43.942,20.115,40.693,44.957a.289.289,0,0,0,.578,0c3.006-22.851-11.008-46.691-36.12-46.062s-38.7,21.412-49.735,41.039a.3.3,0,0,0,.514.3Z",
    transform: "translate(-26.575 -90.794)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M221.309,172.278c-15.941-2.492-33.538-3.494-46.023,8.593-10.6,10.276-14.682,25.908-13.449,40.307,2.813,32.793,30.609,55.233,62.285,58.162.4,0,.385-.578,0-.617-29.826-2.787-56.517-22.992-61.18-53.512-2.274-14.669.925-30.571,10.892-41.926,12.126-13.8,30.7-13.025,47.308-10.417C221.527,172.933,221.694,172.342,221.309,172.278Z",
    transform: "translate(-50.305 -82.903)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M335.584,154.166h0c-26.846-14.823-64.224,15.761-74.744,37.07h0c-20.757-13.294-67.577-23.827-83.864.5h0c-14.129,19.049-5.138,41,8.991,60.05,33.5,45.2,92.278,56.993,102.4,58.727a.976.976,0,0,0,1.079-.617l.116.475a1,1,0,0,0,1.58.565c8.208-6.191,55.066-43.673,64.1-99.265C359.013,188.257,356.893,164.635,335.584,154.166Z",
    transform: "translate(-47.961 -88.722)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M316.929,188.614,290.52,264.8s15.992-14.913,27.437-49.3C329.247,181.575,316.929,188.614,316.929,188.614Z",
    transform: "translate(-13.636 -77.981)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M186.387,211c0,.8,42.157,62.079,42.157,62.079S199.81,258.154,184.4,235.007C179.425,227.557,186.387,211,186.387,211Z",
    transform: "translate(-44.336 -71.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M333.1,239.923l-22.787-35.118c-1.182-1.734-.629-8,.4-9.852a28.258,28.258,0,0,1,12.537-11.265s54.359-34.964,64.6-34.848c1.7,0,13.513,71.418-32.241,88.18",
    transform: "translate(-8.193 -89.124)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M313.093,194.646c18.253-22.17,47.2-36.762,73.408-47.282.976-.385.552-1.978-.437-1.58-26.5,10.636-55.657,25.253-74.141,47.706C311.256,194.3,312.425,195.468,313.093,194.646Z",
    transform: "translate(-7.603 -90.012)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M331.832,193.064a.437.437,0,0,0,.629.206,3.507,3.507,0,0,1,5.138.809c1.734,2.569-1.785,4.907-2.954,6.166-1.683,1.85-4.547,8.2-4.008,14.335.4,4.444,4.855,13.538,4.855,13.538s-12.485,7.283-17.752.629c0,0,4.008-14.669,2.723-18.24,0-.077-6.846,1.5-10.173-10.276-3.134-11.1,4.74-14.862,6.577-15.555C318.4,184.072,325.782,180.489,331.832,193.064Z",
    transform: "translate(-8.218 -79.194)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M317.31,214.07c.218.09,7.964,7.553,7.964,7.553s-5.639,2.941-9.364-1.541Z",
    transform: "translate(-6.413 -70.567)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M311.16,199.107l6.076-1.207s-.938,3.224-2.749,3.263S311.16,199.107,311.16,199.107Z",
    transform: "translate(-7.764 -75.167)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M327.72,192.428a2.145,2.145,0,0,1,2.8.527,2.3,2.3,0,0,1-1.079,2.762",
    transform: "translate(-3.053 -76.811)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M312.721,195.45l.925,2.993-1.618.167a.4.4,0,0,1-.411-.54Z",
    transform: "translate(-7.642 -75.864)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M310.9,188.906s13.847,7.964,21.181,5.51-4.213-18.869-12.1-13.911S310.9,188.906,310.9,188.906Z",
    transform: "translate(-7.838 -80.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M318.006,205.4a12.845,12.845,0,0,0,6.911-3.622c1.708-1.76-1.58,8.426-6.936,9.338C318.006,211.113,318.006,208.095,318.006,205.4Z",
    transform: "translate(-5.824 -74.123)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M316.087,191.774c.617.283-.552-1.284-1.349-1.349a1.285,1.285,0,0,0-1.529,1.117A4.213,4.213,0,0,1,316.087,191.774Z",
    transform: "translate(-7.181 -77.301)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M309.63,191.444a1.4,1.4,0,0,1,1.863.578,4.239,4.239,0,0,0-1.952.591",
    transform: "translate(-8.225 -77.047)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M314.668,194.925c.077.552-.077,1.028-.347,1.066s-.539-.385-.617-.925.077-1.028.347-1.066S314.591,194.386,314.668,194.925Z",
    transform: "translate(-7.046 -76.277)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M311.719,195.324c.077.527-.077.989-.334,1.015s-.514-.36-.591-.886.077-.976.334-1S311.642,194.81,311.719,195.324Z",
    transform: "translate(-7.874 -76.149)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M322.851,197.911a3.006,3.006,0,1,1-2.967-3.031,3.006,3.006,0,0,1,2.967,3.031Z",
    transform: "translate(-6.148 -76.026)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M321.3,356.11c4.6,5.755,17.366,18.432,17.366,18.432l-22.376,21.746c1.284-4.213,4.367-20.321,4.367-20.321l-8.516-11.214S321.4,356.187,321.3,356.11Z",
    transform: "translate(-7.485 -30.158)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M319.827,374.129l-4.881,20.295a.989.989,0,0,0,1.554,1.028c5.986-4.753,22.016-17.687,26.216-21.091a.976.976,0,0,0-.077-1.58c-3.057-2.042-10.982-8.311-13.487-9.929-.4-.27,1.015,9.171-1.285,9.891C325.877,373.32,319.969,374.039,319.827,374.129Z",
    transform: "translate(-6.695 -28.242)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M331.384,378.77l6.769-5.472a.976.976,0,0,0-.077-1.58c-1.529-1.015-4.38-3.2-7.116-5.138Z",
    transform: "translate(-2.131 -27.18)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M318.7,372.52l4.778.5a2.081,2.081,0,0,1,1.837,2.273h0a2.081,2.081,0,0,1-2.273,1.837l-5.369-.578",
    transform: "translate(-5.912 -25.49)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M320.236,356l8.5,8.812s.668,6.679.154,7.167-12.524-12.151-12.524-12.151Z",
    transform: "translate(-6.282 -30.19)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M422.08,309.445c6.088-3.083,15.144-15.555,15.144-15.555S465.65,313.4,465.342,313.4s-21.387.963-21.387.963l-14.271,4.92S422.928,310.293,422.08,309.445Z",
    transform: "translate(23.791 -47.859)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M443.118,315.212l20.937-.912a.989.989,0,0,0,.539-1.785c-6.281-4.38-23.249-16.043-27.719-19.1-.552-.36-1.952.244-2.325.8a99.066,99.066,0,0,1-8.169,10.276c-.334.334,11.843,1.606,13.192,3.609C440.729,309.843,442.489,315.34,443.118,315.212Z",
    transform: "translate(25.013 -48.026)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M443.343,298.343l-7.18-4.932a2.081,2.081,0,0,0-2.222.668c-1.375,2.2-3.147,4.085-5.061,6.949Z",
    transform: "translate(25.726 -48.022)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M440.861,311.744l-.36-5.254a2.081,2.081,0,0,1,1.927-2.209h0a2.068,2.068,0,0,1,2.209,1.927l.36,5.421",
    transform: "translate(29.031 -44.905)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M426.18,313.336l15.144-5.806,1.85,3.635-15.106,4.907Z",
    transform: "translate(24.958 -43.979)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M370.834,285.135c1.58-3.982,1.066-8.362-3.019-14.065s-4.778-9.621-9.968-14.129c-2.916.963-13.115,5.408-18.073,7.707-21.965,10.173-36.415,20-47.911,38.984-11.226,18.574-1.58,43.942,6.05,59.356,6.011,12.151,13.667,19.087,21.656,29.453,1.541.54,8.824-7.347,8.863-8.246-13.783-24.315-15.157-44.238-6.487-58.213,8.118-13.05,17.109-19.344,27.154-25.047C349.1,300.908,365.323,299.046,370.834,285.135Z",
    transform: "translate(-14.71 -58.371)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "m",
    transform: "translate(307.237 198.453)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M314.15,325.981c8.118-13.05,17.109-19.344,27.154-25.048,0,0,16.223-1.862,21.734-15.773,1.58-3.982,1.066-8.362-3.019-14.065s-5.138-9.7-10.34-14.245c-2.916.963-12.742,5.5-17.7,7.8",
    transform: "translate(-314.15 -256.85)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M323.42,265.945c8.657-4.008,24.469-9.685,25.33-8.657,11,5.074,19.267,17.61,21.181,29.068a26.446,26.446,0,0,0,1.927,6.422,66.074,66.074,0,0,0,19.961,26.461c12.845,10.34,32.228,11.021,58.072.36,1.464,3.1,8.131,9.325,7.412,10.79-11.291,6.654-18.933,12.845-31.74,17.289-16.249,5.665-42.619,12.1-59.652-1.349A100.421,100.421,0,0,1,332.938,300.2Z",
    transform: "translate(-4.276 -58.307)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M332,293.52s39.819,75.785,122.27,25.69a108.167,108.167,0,0,1-54.514,23.583C398.626,341.341,360.67,357.423,332,293.52Z",
    transform: "translate(-1.835 -47.965)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M318.658,215.275c-.668.655-10.212,20.4-8.439,28.644,1.182,5.536,11.843,24.405,15.863,35.054,0,0,16.518-4.085,26.615-8.991.462-8.747,3.314-42.3-8.837-55.31a86.607,86.607,0,0,0-10.057-.4S321.329,225.32,318.658,215.275Z",
    transform: "translate(-8.094 -70.513)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M348.719,253.88l-.18,2.659-21.49,9.274Z",
    transform: "translate(-3.243 -59.242)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M318.658,215.272c-.668.655-10.212,20.4-8.439,28.644,1.182,5.536,11.843,24.405,15.863,35.054,0,0,5.138-1.439,30.7-16.377.45-8.747-.771-34.9-12.922-47.911a86.6,86.6,0,0,0-10.057-.4S321.329,225.317,318.658,215.272Z",
    transform: "translate(-8.094 -70.511)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M322.52,278.97s5.138-1.439,30.7-16.377c.45-8.747-.771-34.9-12.922-47.911a86.6,86.6,0,0,0-10.058-.4",
    transform: "translate(-4.532 -70.511)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M335.7,254.6c41.438,6.666,70.416-56.839,70.416-56.839l5.2-14.373c9.184-12.305,10.828-18.831,10.828-18.831l-5.9,8.131,5.266-12.845c.141-.347-.886.437-1.092.745l-6.281,9.621,4.573-13.256a.261.261,0,1,0-.475-.218l-7.5,12.126s4.123-12.755,2.877-11.779-8.118,15.208-8.118,15.208.411-10.212-.771-8.991c-.771.771-1.773,7.373-2.389,11.894-.385,2.916.437,3.365-1.066,5.934L390.414,199.88c-8.927,16.03-29.543,35.966-56.2,31.187,0,0-8.991.257-10.841,10.957S335.7,254.6,335.7,254.6Z",
    transform: "translate(-4.336 -86.922)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M371.756,206.37c-10.083,7.6-20.552,9.158-37.558,10.52,0,0-8.991.257-10.841,10.957s12.318,12.588,12.318,12.588c13.937,2.248,22.376,2.338,32.87-6.217Z",
    transform: "translate(-4.342 -72.758)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M361.645,210l7.309,12.254s-6.872,6.564-9.634,8.156Z",
    transform: "translate(5.937 -71.725)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M384.34,174.25c.925.5,2,1.541,1.67,2.171s-1.978.565-2.89.064",
    transform: "translate(12.708 -81.895)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M387.83,167.507s.771,4.38.732,4.265l1.683-8.991Z",
    transform: "translate(14.048 -85.158)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M299.684,309.561c-3.776-6.088-2.389-14.463,2.094-20.051s11.458-8.7,18.509-9.98,14.271-.951,21.425-.809c21.836.437,44.379-1.285,63.788-11.175s35-29.877,34.206-51.675a12.459,12.459,0,0,0-1.7-6.641c-1.284-1.9-3.853-3.108-6.024-2.171a6.114,6.114,0,0,0-2.98,3.738c-1.285,3.494-1,7.784,1.529,10.52a10.276,10.276,0,0,0,9.454,2.569,22.414,22.414,0,0,0,9.056-4.573c9.839-7.476,17.019-17.983,26.4-25.972s22.71-13.6,34.039-8.67",
    transform: "translate(-11.651 -79.458)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M170.88,238.579a5.138,5.138,0,0,1,3.853.989l1.284-15.414s2.261-4.509,5.074-3.468,4.8-.077,6.422.462c4.252,1.49,4.65-2.312,4.65-2.312s-4.3-5.934-7.951-6.846-14.232.36-17.418,5.485-5.254,8.568,3.609,21.579l5.074.976",
    transform: "translate(-49.611 -71.236)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M181.125,219.04c1.644,1.593,7.232-.822,7.257-2.569a15.992,15.992,0,0,0-1.451-5.9c-.373-.822-1.991-1.362-2.775-1.8a3.494,3.494,0,0,0-1.978-.372,7.065,7.065,0,0,0-5.433,4.47,5.549,5.549,0,0,0,0,5.395",
    transform: "translate(-46.203 -72.184)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M180.512,221.5c2.569,1.927,6.975.321,9.094-1.593,2.71-2.428,1.477-7.527-.321-10.276-2.3-3.455-7.591-3.853-10.713-1.541-3.507,2.569-5.523,7.707-3.237,11.715a2.261,2.261,0,0,0,3.853-2.286c-2.235-3.853,4.945-9.313,6.628-4.444a10.766,10.766,0,0,1,.706,2.813c0,.629.257.424-.462.938s-2.569,1.284-3.314.706c-2.325-1.76-4.586,2.171-2.286,3.918Z",
    transform: "translate(-46.681 -72.681)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M177.384,215.049a3.854,3.854,0,0,0-.706-2.068,5.677,5.677,0,0,0-1.567-1.747,2.761,2.761,0,0,0-2.248-.437c-1.285.372-1.952,1.824-2.3,3.134a2.234,2.234,0,0,0-.116.963.848.848,0,0,0,.6.694c-.1.141-.218.27-.334.411a.912.912,0,0,0-.5-.925,2.441,2.441,0,0,0-1.092-.218,9.954,9.954,0,0,0-2.954.411,2.569,2.569,0,0,0-1.76,1.285,2.993,2.993,0,0,0,.527,2.569,2.184,2.184,0,0,0,1.079,1.117",
    transform: "translate(-49.539 -71.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M180.145,215.552c-.45-3.648-3.853-7.912-7.938-6.217-3.07,1.285-5.138,6.666-1.811,8.709l-.462-3.558-.334.411,3.789,1c-.732-3.725-6.024-3.2-8.58-1.824-3.481,1.875-2.492,6.731.552,8.529a2.274,2.274,0,0,0,2.286-3.918c-.886-.527,0-.758.334-.912l.886-.128q1.426.231.154-.54a2.274,2.274,0,0,0,3.853.989l.334-.4a2.312,2.312,0,0,0-.462-3.558c.989.6.719-.488,1.541-.424.629,0,1.285,1.349,1.387,1.837.347,2.852,4.894,2.89,4.534,0Z",
    transform: "translate(-50.026 -72.023)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M222.81,446c0,1.285,14.63,2.261,21.734,2.261s12.845-1.015,12.845-2.261-5.767-2.261-12.845-2.261S222.81,444.755,222.81,446Z",
    transform: "translate(-32.898 -5.229)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M109.538,444.222c0,1.284-14.63,2.261-21.734,2.261s-12.845-1.015-12.845-2.261S80.7,442,87.856,442,109.538,442.976,109.538,444.222Z",
    transform: "translate(-74.96 -5.724)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M242.206,423.43l-4.316,31.213,44.238,2.364.18-3.481-24.367-15.915,6.885-12.447Z",
    transform: "translate(-28.608 -11.007)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M242.206,423.43l-4.316,31.213,44.238,2.364.18-3.481L244.942,437.2l2.877-13.757Z",
    transform: "translate(-28.608 -11.007)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M257.941,435.133l24.367,15.915-.18,3.481-44.238-2.363,2.774-20.025",
    transform: "translate(-28.608 -8.529)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ad",
    x1: 6.294,
    y2: 4.098,
    transform: "translate(227.521 429.558)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ad",
    x1: 6.307,
    y2: 4.098,
    transform: "translate(230.951 431.678)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M135.208,408.09l-29.492,2.132L98.96,453.8l3.442.54,18.24-22.556,16.608-2.286Z",
    transform: "translate(-68.132 -15.371)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M136.095,421.77,106.6,423.9,98.96,449.913l3.442.54,18.24-22.556,16.608-2.286Z",
    transform: "translate(-68.132 -11.479)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M124.44,409.08l-18.766,1.182L98.93,453.844l3.442.527L120.6,431.815",
    transform: "translate(-68.141 -15.089)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ad",
    x1: 5.087,
    y1: 6.949,
    transform: "translate(40.603 418.191)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ad",
    x1: 5.087,
    y1: 6.949,
    transform: "translate(42.94 416.097)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ae",
    d: "M253.32,322.27c-13.217,4.136-46.73,17.276-47.693,18.5.3,5.87-4.033,31.162-14.322,49.967-8.465,15.414-26.049,26.794-66.305,36.389,0,.36,2.646,24.726,3.532,26.4,23.647-.989,70.647-6.5,91.07-21.194,14.348-10.276,28.156-29.543,34.45-51.816C257.688,367.612,253.32,322.27,253.32,322.27Z",
    transform: "translate(-60.724 -39.785)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(145.764 282.549)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ae",
    d: "M201.555,432.375C215.9,422.1,229.711,402.832,236,380.559c3.635-12.845-.732-58.239-.732-58.239-13.217,4.136-45.869,14.438-46.832,15.645",
    transform: "translate(-188.44 -322.32)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "ae",
    d: "M192.849,377.576c-8.991-7.142-4.8-29.466-2.877-36.788s.257-1.284,3.6-7.707c3.044.064,23.2-6.14,28.426-7.463,22.89-5.793,63.287-9.312,80.293,7.193,25.06,24.405-16.39,108.835-20.436,122.347-1.285,1.066-24.405-1.079-25.137-1.374,4.83-30.083,16.6-72.792,8.234-78.354C255.467,369.073,207.312,389.008,192.849,377.576Z",
    transform: "translate(-43 -40.205)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(213.713 335.149)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ae",
    d: "M253.491,442.78c.886.668-11.381-.861-12.151-1.156,4.83-30.083,16.6-72.792,8.234-78.354l6.577.1s7.771.45,5.549,16.416Z",
    transform: "translate(-241.34 -363.27)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M243.28,339.779,191.72,362.27s-21.836-52.548-24.559-80.691c-1.207-12.652,5.485-24.611,17.983-27.167h0c19.177-4.766,36.6,16.506,39.485,27.4Z",
    transform: "translate(-48.77 -59.285)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M172.21,236.846l2.389,26.448,23.4-2.71-8.94-19.126L174,234.56Z",
    transform: "translate(-47.294 -64.738)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M174,236.3l14.733,5.138.976,2.389S191.212,253.718,174,236.3Z",
    transform: "translate(-46.784 -64.243)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "af",
    d: "M173.941,251.91l-2.261,8.632,29.055,2.312-4.6-7.1Z",
    transform: "translate(-47.444 -59.802)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "af",
    d: "M189.6,249c.385,0,5.343,6.795,5.343,6.795l3.211,5.9-6.962-4.714Z",
    transform: "translate(-42.346 -60.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M189.953,248.98l1.439,7.6-3.031-.552Z",
    transform: "translate(-42.699 -60.636)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ag",
    d: "M243.249,333.61,191.689,356.1s-21.836-52.548-24.559-80.691",
    transform: "translate(-48.739 -53.117)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ag",
    d: "M228.957,325.19l-9.492,3.34a33.4,33.4,0,0,1-42.388-19.922l-1.066-2.877,6.127-.951",
    transform: "translate(-46.213 -44.761)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M269.918,300.158s3.853-16.942,5.472-15.876-.167,8.452-.193,9.749c-.1,3.853,14.964-15.054,16.043-13.988s-4.136,10.276-4.136,10.276,3.853-9.223,4.881-8.349-1.22,9.865-1.22,9.865,2.222-8.324,2.646-7.155-.963,9.223-.963,9.223,1-5.69.668-3.853c-2.312,12.408-14.861,22.684-14.861,22.684s-29.954,23.3-46.576,26.525c-19.177,3.725-38.714-4.175-46.781-20.411l-17.3-34.835c-3.853-10.636,2.248-22.967,13.654-27.527h0c11.393-4.56,18.728,4.11,22.594,14.759l15.414,31.842c4.83,9.968,22.273,10.2,33.294,5.318l16.287-7.232a2.029,2.029,0,0,0,1.028-1.04Z",
    transform: "translate(-48.935 -58.854)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M202.29,296,186.76,315.743a35.349,35.349,0,0,1-7.09-12.2Z",
    transform: "translate(-45.171 -47.259)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ah",
    d: "M174.777,322.2l-9.4-39.344c-2.261-11.7,3.738-22.26,14.271-26.293h0a20.449,20.449,0,0,1,26.383,11.792L221.7,300.039",
    transform: "translate(-49.373 -58.863)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ai",
    d: "M178.422,319.945l-10.276-39.125c-2.569-11.5,2.569-21.515,12.164-24.983h0c9.634-3.468,20.847,2.184,25.048,12.614l15.9,31.56S182.609,318.763,178.422,319.945Z",
    transform: "translate(-48.637 -58.976)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M173.476,234.007a1.811,1.811,0,0,1-.938,1.207c-1.811.655-4.586.206-3.635,4.02,1.015,4.136,5.446,1.952,6.076,2.492,1.284,1.117,4.033,4.329,8.722,4.855,2.852.321,8.3.745,10.276-2.672s3.725-6.885-4.277-24.791c0,0-2.081-1.76-3.7-.591s-5.292-.411-7.527-.347c-1.824,0-4.1.18-4.354,6.487C173.989,227.572,173.655,231.579,173.476,234.007Z",
    transform: "translate(-48.289 -69.413)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M190.435,230.18a45.623,45.623,0,0,1-6.885,2.672s3.776,2.749,5.536,1.451S190.435,230.18,190.435,230.18Z",
    transform: "translate(-44.067 -65.984)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M180.745,225.181c-.565.848-.437-2.184.514-2.877a1.991,1.991,0,0,1,2.787.334,6.23,6.23,0,0,0-3.3,2.543Z",
    transform: "translate(-44.961 -68.345)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M186.2,220.934c-.925-.167-1.374.963-1.284,1.631,0,0,1.439-.706,1.991-.167",
    transform: "translate(-43.683 -68.619)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M183.485,226.863c.128.527.45.912.719.848s.36-.552.218-1.092-.45-.912-.719-.848S183.343,226.324,183.485,226.863Z",
    transform: "translate(-44.105 -67.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M186.3,225.662c.128.514.437.886.694.822s.347-.527.206-1.04-.424-.886-.681-.822S186.174,225.11,186.3,225.662Z",
    transform: "translate(-43.301 -67.567)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M172.707,232.07c-1.028,0-2.222.784-2.2,1.811a2.286,2.286,0,0,0,2.286,1.888",
    transform: "translate(-47.777 -65.446)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M186,226.87l.809,3.853,1.863-.809a.488.488,0,0,0,.116-.835Z",
    transform: "translate(-43.37 -66.926)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aj",
    d: "M253.233,266.88c-3.2,6.628-21.836,41.4-39.626,50.866-16.287,8.683-42.285,8.2-47.526,25.9-.617,2.107-1.028,4.534.218,6.345a6.9,6.9,0,0,0,5,2.4,25.3,25.3,0,0,0,17.61-4.778",
    transform: "translate(-49.205 -55.543)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aj",
    d: "M242.484,314.027a26.614,26.614,0,0,0,5.767,5.369,3.854,3.854,0,0,0,2.415.912,2.89,2.89,0,0,0,2.4-2.569,7.45,7.45,0,0,0-.629-3.674c-3.108-8.388-9.056-15.542-11.843-24.046a3.7,3.7,0,0,1-.218-2.222c.552-1.76,3.173-1.785,4.663-.706s2.4,2.8,3.853,3.853",
    transform: "translate(-27.924 -50.001)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M255.21,298.36c11.894,15.9,32.639,28.7,52.767,36.081,12.138,4.457,25.69,8.054,33.808,17.045,1.207,1.285,2.017,3.712.218,4.342a3.391,3.391,0,0,1-1.721,0c-2.351-.411-10.777-3.147-12.6-4.509",
    transform: "translate(-23.681 -46.588)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "ak",
    cx: 16.852,
    cy: 16.852,
    r: 16.852,
    transform: "translate(48.477 172.674)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M122.295,246.337h0c1.284-1.285,3.853,0,4.74,1.195.925-1.195,3.43-2.569,4.753-1.195h0c1.079.976.873,2.569.347,3.943A10.815,10.815,0,0,1,127,255.675h0a10.623,10.623,0,0,1-5.138-5.395C121.422,248.855,121.216,247.352,122.295,246.337Z",
    transform: "translate(-61.719 -61.551)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "ak",
    cx: 16.852,
    cy: 16.852,
    r: 16.852,
    transform: "translate(232.993)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M265.955,111.907h0c1.284-1.284,3.853,0,4.74,1.195.912-1.182,3.43-2.569,4.74-1.195h0c1.079.989.886,2.569.347,3.956a10.636,10.636,0,0,1-5.138,5.382h0a10.52,10.52,0,0,1-5.138-5.382C265.082,114.437,264.876,112.9,265.955,111.907Z",
    transform: "translate(-20.85 -99.794)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "al",
    cx: 5.665,
    cy: 5.665,
    r: 5.665,
    transform: "translate(63.454 107.447)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M420.484,132.5a5.292,5.292,0,1,1-5.279-5.279,5.292,5.292,0,0,1,5.279,5.279Z",
    transform: "translate(20.326 -95.275)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M416.38,246.968a2.261,2.261,0,1,0,2.261-2.248,2.261,2.261,0,0,0-2.261,2.248Z",
    transform: "translate(22.17 -61.848)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "ak",
    cx: 5.125,
    cy: 5.125,
    r: 5.125,
    transform: "translate(156.117 37.391)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "ak",
    cx: 5.125,
    cy: 5.125,
    r: 5.125,
    transform: "translate(287.443 26.974)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "ak",
    cx: 5.125,
    cy: 5.125,
    r: 5.125,
    transform: "translate(468.543 153.419)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "ak",
    cx: 5.125,
    cy: 5.125,
    r: 5.125,
    transform: "translate(20.899 218.337)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "an",
    d: "M142.866,303.173a4.213,4.213,0,1,1-4.213-4.213A4.213,4.213,0,0,1,142.866,303.173Z",
    transform: "translate(-58.039 -46.417)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M246.029,214.562a4.688,4.688,0,0,0-2.98,6.024c.848,2.839,3.6,4.059,7.707,5.883l2.274,1.015a.861.861,0,0,0,.642,0,.912.912,0,0,0,.514-.385c.475-.745.912-1.439,1.349-2.094,2.466-3.853,4.1-6.333,3.25-9.171a4.676,4.676,0,0,0-5.78-3.417,4.329,4.329,0,0,0-2.929,2.993,4.342,4.342,0,0,0-4.085-.9Zm5.6,2.877s0-2.569,1.927-3.224a2.89,2.89,0,0,1,3.52,2.184c.6,2.042-.771,4.149-3.044,7.707l-.925,1.439-1.567-.771c-3.853-1.683-6.127-2.71-6.731-4.74a2.864,2.864,0,0,1,1.747-3.751c1.94-.578,3.314,1.529,3.378,1.631a.925.925,0,0,0,1.04.4.95.95,0,0,0,.655-.9Z",
    transform: "translate(-27.217 -71.085)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "q",
    cx: 0.912,
    cy: 0.912,
    r: 0.912,
    transform: "translate(207.291 135.796)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M270.68,216.054a3.659,3.659,0,1,0,2.582-6.846l-5.408-2.068-3.3-11a.925.925,0,0,0-1.13-.617l-5.266,1.58a.9.9,0,0,0-.6,1.13l1.67,5.613-9.248-3.532a3.674,3.674,0,0,0-4.239,1.284l-5.138,7.116A.925.925,0,0,0,240.8,210a.938.938,0,0,0,1.284-.206l5.138-7.116a1.76,1.76,0,0,1,.951-.681,1.824,1.824,0,0,1,1.169,0l23.275,8.9a1.837,1.837,0,0,1-.128,3.468,1.786,1.786,0,0,1-1.156,0l-21.323-8.156a.873.873,0,0,0-1.04.283l-13.384,18.535a1.85,1.85,0,0,1-1.13.719,1.618,1.618,0,0,1-1.927-.873,1.862,1.862,0,0,1,.1-2l4.637-6.422a.938.938,0,0,0-.206-1.284.925.925,0,0,0-1.284.206l-4.624,6.422a3.648,3.648,0,0,0-.218,3.982,3.4,3.4,0,0,0,3.853,1.76,3.6,3.6,0,0,0,2.261-1.426h0l.116-.167,3.6,12.023a5.472,5.472,0,0,0-2.685,5.344,4.56,4.56,0,0,0,4.894,7.193l36.107-10.764a4.56,4.56,0,0,0,.154-8.7,5.433,5.433,0,0,0-5.138-3.006l-3.584-12.023Zm-11.111-17.469,3.507-1.053,2.569,8.786-4.3-1.644Zm-7.463,47.269-9.646,2.877a2.736,2.736,0,0,1-2.749-4.521.886.886,0,0,0,.244-.822,3.635,3.635,0,0,1,5.819-3.571.938.938,0,0,0,1.028.077,2.865,2.865,0,0,1,.578-.27,2.749,2.749,0,0,1,3.4,1.811.925.925,0,0,0,.873.848,1.824,1.824,0,0,1,.45,3.571Zm13.731-9.287a3.648,3.648,0,0,0-.925,1.67l-10.764,3.211a3.481,3.481,0,0,0-1.67-.9,4.84,4.84,0,0,0-.218-.45l13.5-4.02a3.494,3.494,0,0,0,.077.488Zm-10.7,8.388a3.686,3.686,0,0,0,0-1.9l9.814-2.929a3.661,3.661,0,0,0,.989,1.618Zm22.607-12.845a.9.9,0,0,0,.642.552,2.736,2.736,0,0,1,.18,5.292l-9.634,2.864a1.824,1.824,0,0,1-1.593-3.224.912.912,0,0,0,.27-1.182,2.762,2.762,0,0,1,1.863-3.391,2.851,2.851,0,0,1,.629-.09.912.912,0,0,0,.809-.629,3.687,3.687,0,0,1,2.415-2.338,3.648,3.648,0,0,1,4.419,2.145Zm-5.485-3.7a5.472,5.472,0,0,0-2.877,2.775l-.462.1a4.586,4.586,0,0,0-2.98,2.8l-15.054,4.444a4.585,4.585,0,0,0-4.02-.706,3.1,3.1,0,0,0-.45.154,5.485,5.485,0,0,0-3.93-.732l-3.943-13.256c.976-1.362,10.353-14.335,11.47-15.9L268.33,215.1Z",
    transform: "translate(-30.725 -75.852)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoritesImg);
export default __webpack_public_path__ + "static/media/favoritesImg.04d1b59445b981f90f0d0380c72b4b8e.svg";
export { ForwardRef as ReactComponent };